module.exports = __webpack_public_path__ + "static/media/n19.c2592dd7.jpg";